import axios from './index'

const prefix = 'client'

export const read = params => {
  if (typeof params === 'object' || params === undefined) {
    return axios.get(prefix, { params })
  } else {
    return axios.get(`${prefix}/${params}`)
  }
}

export const create = payload => {
  return axios.post(prefix, payload)
}

export const update = payload => {
  return axios.put(prefix, payload)
}

export const del = id => {
  return axios.delete(`${prefix}/${id}`)
}
